import { isInReviewsLayoutAlignmentExperiment } from '@client/redux/experiments/selectors/reviews-layout-alignment';
import { useAppSelector } from '@client/redux/hooks';
import { formatReviewRating } from '@decorators/vendor/helpers';
import { useLiteStorefront } from '@hooks/use-lite-storefront';
import { TextBody } from '@tkww/orion-web-ds-text';
import React, { type FC } from 'react';
import Styles from './styles.scss';

interface Props {
	overallRating: number;
}

const ReviewRating: FC<Props> = ({ overallRating = 0 }) => {
	const isLiteStorefront = useLiteStorefront();
	const inReviewsLayoutAlignmentExperiment = useAppSelector(
		isInReviewsLayoutAlignmentExperiment,
	);
	const displayRating = formatReviewRating(overallRating, {
		showDecimals: !isLiteStorefront || inReviewsLayoutAlignmentExperiment,
		preserveZero: true,
	});

	return (
		<TextBody size="md" className={Styles.overallRating} bold aria-hidden>
			{displayRating}
		</TextBody>
	);
};

export default ReviewRating;
